import React from 'react';

function UnderConstruction() {
  return (
    <h2>🚧 This page is under construction 🚧</h2>
  );
}

export default UnderConstruction;
